module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon2.e3514779.png";